export default __webpack_public_path__ + "static/media/rw.2dbaa32b.svg";